import API from "../BaseURL";

const configJson = {
  headers: {
    "content-type": "application/json",
  },
};

export async function getExploitationCoordinateByDomain(domain_id) {
  const res = await API.get(`/exploitations/domain/${domain_id}`, configJson);
  return res;
}

export async function getkmlFilesPathByExploitationID(exploitaionId) {
  const res = await API.get(
    `/exploitations/${exploitaionId}/files`,
    configJson
  );
  return res;
}
